import { useTranslation } from 'react-i18next'

interface YourNameStepProps {
  firstName: string
  lastName: string
  onFirstNameChange: (val: string) => void
  onLastNameChange: (val: string) => void
}

export default function YourNameStep({
  firstName,
  lastName,
  onFirstNameChange,
  onLastNameChange,
}: YourNameStepProps) {
  const { t } = useTranslation('onboarding')

  return (
    <div>
      <div className="text-center mb-6">
        <h2 className="font-display text-2xl text-ivory font-semibold mb-1">{t('yourName.heading')}</h2>
        <p className="text-pearl/50 text-sm">{t('yourName.subtitle')}</p>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-pearl/60 text-xs mb-1.5 ml-1">{t('yourName.firstNameLabel')}</label>
          <input
            type="text"
            value={firstName}
            onChange={e => onFirstNameChange(e.target.value)}
            placeholder={t('yourName.firstNamePlaceholder')}
            maxLength={100}
            autoFocus
            className="w-full bg-slate-dark/80 border border-gold/10 rounded-xl px-4 py-3 text-ivory text-sm placeholder:text-pearl/55 focus:outline-none focus:border-gold/40 transition-colors"
          />
        </div>

        <div>
          <label className="block text-pearl/60 text-xs mb-1.5 ml-1">{t('yourName.lastNameLabel')}</label>
          <input
            type="text"
            value={lastName}
            onChange={e => onLastNameChange(e.target.value)}
            placeholder={t('yourName.lastNamePlaceholder')}
            maxLength={100}
            className="w-full bg-slate-dark/80 border border-gold/10 rounded-xl px-4 py-3 text-ivory text-sm placeholder:text-pearl/55 focus:outline-none focus:border-gold/40 transition-colors"
          />
        </div>
      </div>
    </div>
  )
}
